import {
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  IconButton,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  DesktopWindows,
  PermMediaRounded,
  ShoppingCart,
  Store,
  Devices
} from '@material-ui/icons';
import { OnlineOrderingStore } from 'kiolyn-api';
import { isEmpty } from 'lodash';
import React from 'react';

const useStyles = makeStyles(() => ({
  card: {
    minWidth: 18 * 20,
    maxWidth: 20 * 20
  },
  media: {
    height: 0,
    paddingTop: '40%',
    backgroundSize: 'contain'
  },
  permMediaWrapper: {
    position: 'relative',
    width: '100%',
    paddingTop: '40%'
  },
  permMedia: {
    fontSize: 100,
    position: 'absolute',
    top: 16,
    left: 136
  },
  cardActions: {
    justifyContent: 'center'
  },
  orderButton: {
    marginLeft: 'auto'
  }
}));

interface StoreCardProps {
  store: OnlineOrderingStore;
  onOpenOrderingPage: (storeid: string) => void;
  onOpenScreensPage: (storeid: string) => void;
  onOpenKiosksPage: (storeid: string) => void;
  onOpenFFDPage: (storeid: string) => void;
}

export default function StoreCard({
  store: { id, name, address, description, image_url },
  onOpenOrderingPage,
  onOpenScreensPage,
  onOpenKiosksPage,
  onOpenFFDPage
}: StoreCardProps) {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardActionArea onClick={() => onOpenOrderingPage(id || '')}>
        {isEmpty(image_url) ? (
          <div className={classes.permMediaWrapper}>
            <PermMediaRounded
              className={classes.permMedia}
              color="disabled"
              fontSize="inherit"
            />
          </div>
        ) : (
          <CardMedia className={classes.media} image={image_url} title={name} />
        )}
      </CardActionArea>
      <CardContent>
        <Typography gutterBottom variant="h5" component="h2">
          {name}
        </Typography>
        <Typography gutterBottom variant="h6" component="h3">
          {address}
        </Typography>
        <Typography variant="body2" color="textSecondary" component="p">
          {description || ''}
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
        <IconButton
          aria-label="show screens"
          onClick={() => onOpenScreensPage(id || '')}
        >
          <DesktopWindows />
        </IconButton>
        <IconButton
          aria-label="open kiosk"
          onClick={() => onOpenKiosksPage(id || '')}
        >
          <Store />
        </IconButton>
        <IconButton
          aria-label="open ffd"
          onClick={() => onOpenFFDPage(id || '')}
        >
          <Devices />
        </IconButton>
        <IconButton
          aria-label="open ordering"
          className={classes.orderButton}
          onClick={() => onOpenOrderingPage(id || '')}
        >
          <ShoppingCart />
        </IconButton>
      </CardActions>
    </Card>
  );
}
